// itemsSlice.ts
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CameraType} from 'expo-camera';

interface CameraState {
  shootingMode: 'photo' | 'video';
  cameraFacing: CameraType;
  recording: boolean;
}

const initialState: CameraState = {
  shootingMode: 'photo',
  cameraFacing: 'back',
  recording: false,
};

const cameraSlice = createSlice({
  name: 'camera',
  initialState,
  reducers: {
    setShootingMode(
      state,
      action: PayloadAction<CameraState['shootingMode']>,
    ) {
      state.shootingMode = action.payload;
    },
    setFacing(state, action: PayloadAction<CameraType>) {
      state.cameraFacing = action.payload;
    },
    setRecording(state, action: PayloadAction<boolean>) {
      state.recording = action.payload;
    },
  },
});

export const {setShootingMode, setFacing, setRecording} =
  cameraSlice.actions;
export default cameraSlice.reducer;
